module.exports = __webpack_public_path__ + "static/media/qr-code-placeholder.2256a342.png";